import { createContext, useContext } from 'react';

/** Reuses the chat's active-entity hint; record IDs never enter visible copy. */
export const AdCardEditChatContext = createContext<{
  disabled: boolean;
  upload?: (file: File) => Promise<string>;
  send: (
    text: string,
    adId?: string,
    creativeAssetIds?: string[]
  ) => Promise<boolean>;
} | null>(null);
export const AdCardEditTargetContext = createContext<string | undefined>(
  undefined
);
export const useAdCardEditChat = () => useContext(AdCardEditChatContext);
export const useAdCardEditTarget = () => useContext(AdCardEditTargetContext);
